import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tarife-servicii',
  templateUrl: './tarife-servicii.component.html',
  styleUrls: ['./tarife-servicii.component.scss']
})
export class TarifeServiciiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
